module.exports = __webpack_public_path__ + "img/qrcode.aa069443.jpg";